
// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
export function isArray(x: any): boolean {
  return Array.isArray(x);
}



/** WEBPACK FOOTER **
 ** ./src/helper/is-array.ts
 **/